import React from "react";
import InvalidFeedback from "../InvalidFeedback";

// interface DataType {
//     value: string,
//     text: string,
//     disabled?: boolean,
// }

export default React.forwardRef(( { label,data, errors, children, sizeClass = 'form-control-lg', ...register }: any, ref) => {

    return  (
        <>
            <label className="form-label" >{label}</label>
            <select className={'form-control ' + (sizeClass) + (errors ? 'is-invalid' : '')} {...register} ref={ref}>
                {
                    data.map( (d,i) => <option key={i} value={d.value} disabled={d.disabled}>{d.text}</option>)
                }
            </select>
            <InvalidFeedback error={errors} />
        </>
    )
}
)